import { FC } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./shared/layout/Layout";
import { Login } from "./pages";
import { ROLE } from "./features/auth/AuthSlice";
import routes from "./routes/routes";
import AuthCheckRoute from "./routes/AuthCheckRoute";
import PrivateRoute from "./routes/PrivateRoute";
import ForgotPassword from "./pages/auth/forgotPassword/ForgotPassword";
import { ThemeProvider } from "@mui/styles";
import { useAppSelector } from "./app/hooks";
import { selectTheme } from "./features/theme/ThemeSlice";
import { createTheme } from "@mui/material";
import { trTR } from "@mui/material/locale";
import ResetPassword from "./pages/auth/resetPassword/ResetPassword";

const App: FC = () => {
  const dark = useAppSelector(selectTheme);

  const theme = createTheme(
    {
      palette: {
        mode: dark ? "dark" : "light",
        text: {
          primary: dark ? "#8f9ebd" : "#505050",
        },
      },
      typography: {
        allVariants: {
          color: dark ? "#8f9ebd" : "#505050",
        },
      },
    },
    trTR
  );
  return (
    <ThemeProvider theme={theme}>
      <Routes>
        <Route path="/login" element={<AuthCheckRoute component={Login} />} />
        <Route
          path="/forgot"
          element={<AuthCheckRoute component={ForgotPassword} />}
        />
        <Route
          path="/reset-password"
          element={<AuthCheckRoute component={ResetPassword} />}
        />
        <Route path="/" element={<Layout />}>
          {routes.map((route: any, index: number) => (
            <Route
              key={index}
              path={route.path}
              element={
                <PrivateRoute
                  roles={[ROLE.ADMIN]} // later implement roles to routes
                  component={route.component}
                />
              }
            >
              {route.children &&
                route.children.map((item: any, index: number) => (
                  <Route
                    key={index}
                    path={item.path}
                    element={
                      <PrivateRoute
                        roles={[ROLE.ADMIN]}
                        component={item.component}
                      />
                    }
                  />
                ))}
            </Route>
          ))}
        </Route>
      </Routes>
    </ThemeProvider>
  );
};

export default App;
